{
    "items": [
        [true, 0, "lightgreen", "Geactualiseerd (2023-2024)"],
        [true, 0, "green", "Definitief / vastgesteld RvB"],
        [true, 0, "purple", "Voorlopig"],
        [true, 0, "red", "Nog niet ingeleverd"]
        ],
    "title": "routekaart Poliklinieken"
}
